<template>
  <div class="ly-table">
    <!-- 
    <div class="table-header">
      <span class="table-title"> {{ $t("messages.titElectFcltUse") }} </span>
    </div> -->
    <div class="table-header">
      <el-form label-width="120px">
        <el-row :gutter="60">
          <el-col :span="12">
            <el-form-item :label="$t('messages.lblInquiryRange')">
              <div class="table-option range">
                <el-date-picker
                  size="medium"
                  v-model="searchForm.firstOpnDt"
                  type="daterange"
                  range-separator="~"
                  start-placeholder="YYYY-MM-DD"
                  end-placeholder="YYYY-MM-DD"
                  @input="chgFirstOpnDt"
                />
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="" style="float: right">
              <el-button
                plan
                type="save"
                size="medium"
                @click="getUsageStatusPowerReport(1)"
              >{{ $t("messages.btnInquiry") }}</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="table-body">
      <div class="ly-sort ly-sort-his">
        <div class="sort-count">
          <p class="table-cell-all">
            {{ $t("messages.all") }}
            <span class="table-cell-count">{{ pageInfo.totalListSize }}</span
            >{{ $t("messages.unit") }}
          </p>
        </div>
        <div v-if="!$isMobile()">
          <el-button size="small" type="save" @click="openGraphModal">{{
            $t("messages.btnElectGraph")
          }}</el-button>
          <el-button plain size="small" type="excel" @click="downloadExcel"
            >{{ $t("messages.btnExcel") }}<i class="icon-DownloadSimple"></i
          ></el-button>
        </div>
      </div>
      <idc-list
        :tableHeader="tableHeader"
        :tableData="tableData"
        @clickRow="clickRow"
      >
        <template #index="{ scope }">
          {{
            pageInfo.totalListSize -
            (pageInfo.curPage - 1) * pageInfo.pageListSize -
            scope.$index
          }}
        </template>
      </idc-list>
      <idc-pagenation
        :pageInfo.sync="pageInfo"
        @movePage="getPagingUsageStatusPowerReport"
        v-if="tableData.length > 0" 
        layout="prev, pager, next"
      ></idc-pagenation>
          <loading
              :active.sync="isLoadingLayer"
              :can-cancel="false"
              :is-full-page="false"
          >
          </loading>      
    </div>
    <!--modal-->
    <idc-modal
      :visible.sync="modalTraffic"
      :closeOnClickModal="false"
      :beforeClose="beforeClose"
      :title="$t('messages.titReportPowerUsage')"
      width="1410px"
      top="2vh"
    >
      <template #content>
        <div class="graph">
          <div class="graph-title">
            {{ $t("messages.titChartWeeklyPower") }}
          </div>
          <div class="graph-area graph-area-weekly"></div>
        </div>
      </template>
    </idc-modal>

    <idc-modal
      :visible.sync="modalPower"
      :closeOnClickModal="false"
      :beforeClose="beforeClose"
      :title="modalTitle"
      width="1410px"
      top="2vh"
    >
      <template #content>
        <realtime-power
          ref="refChartModal"
          :key="modalKey"
          :modalKey="modalKey"
          :isGraph="isGraph"
          :trafficData="trafficData"
          :popType="popType"
        ></realtime-power>
      </template>
    </idc-modal>

  </div>
</template>

<script>
import IdcList from "@/components/common/IdcList";
import IdcPagenation from "@/components/common/IdcPagenation";
import IdcModal from "@/components/common/IdcModal.vue";
import RealtimePower from "@/components/modal/RealtimePower.vue";
import Loading from "vue-loading-overlay";
import {
  getNow,
  parseDateRange,
  getDateStatisticsRange,
  commonExcelDownload,
  getDateFormatter,
} from "@/assets/js/common.js";

export default {
  components: {
    IdcList,
    IdcPagenation,
    IdcModal,
    RealtimePower,
    Loading,
  },

  data() {
    return {
      count: 25,
      modalTitle:'',
      modalPower:false,
      modalKey: "",
      trafficData: [],
      isGraph: true,
      popType: "",
      totalSize: 0,
      countList: [
        {
          value: 25,
          label: "25개",
        },
        {
          value: 50,
          label: "50개",
        },
      ],
      tableHeader : [
            {
              prop: "custHnglNm",
              label: "고객명",
              width: 60,
            },
            {
              prop: "idcCdNm",
              label: "DC",
              width: 30,
            },
            {
              prop: "flrDivNm",
              label: "층구분",
              width: 30,
            },
            {
              prop: "flrNm",
              label: "층",
              width: 30,
            },
            {
              prop: "eqpRoomAssetNm",
              label: "룸",
              width: 30,
            },
            {
              prop: "rackAssetNm",
              label: "랙명",
              width: 60,
            },
            {
              prop: "rackDivCdNm",
              label: "랙유형",
              width: 50,
            },
            {
              prop: "sttusCdNm",
              label: "사용상태",
              width: 40,
            },
            {
              prop: "contElect",
              label: "랙당계약전력(kw)",
              width: 50,
            },
            {
              prop: "rackTotElect",
              label: "랙 총 전력(Kw)",
              // label: this.$t("messages.lblPowerMax"),
              width: 50,
            },

            // {
            //   prop: "avgaUseQnt",
            //   label: "전류(A)",
            //   width: 30,
            // },
            // {
            //   prop: "avgUseQnt",
            //   label: "평균사용량(kw)",
            //   width: 30,
            // },
            // {
            //   prop: "minUseQnt",
            //   label: "최소사용량(kw)",
            //   width: 30,
            // },
            // {
            //   prop: "maxUseQnt",
            //   label: "최대사용량(kw)",
            //   width: 30,
            // },
        // {
        //   prop: "idcCdNm",
        //   label: "데이터센터",
        //   // label: this.$t("messages.lblRoomName"),
        //   width: 100,
        // },
        // {
        //   prop: "rackLo",
        //   label: "서버실",
        //   // label: this.$t("messages.lblRoomName"),
        //   width: 120,
        // },
        // {
        //   prop: "rackNo",
        //   label: "랙번호",
        //   // label: this.$t("messages.lblRackNumber"),
        //   width: 120,
        // },
        // {
        //   prop: "rackDivCdNm",
        //   label: "랙유형",
        //   // label: this.$t("messages.lblRackType"),
        //   width: 100,
        // },
        // {
        //   prop: "custHnglNm",
        //   label: "고객명",
        //   // label: this.$t("messages.lblContractPower"),
        //   width: 120,
        // },
        // {
        //   prop: "basContElect",
        //   label: "랙기본계약전력",
        //   // label: this.$t("messages.lblContractPower"),
        //   width: 120,
        // },
        // {
        //   prop: "rackTotElect",
        //   label: "랙 총 전력(Kw)",
        //   // label: this.$t("messages.lblPowerMax"),
        //   width: 100,
        // },
      ],
      tableData: [],
      modalTraffic: false,
      isLoadingLayer: true,
      pageInfo: {
        curPage: 1,
        startIndex: 0,
        lastIndex: 25,
        pageListSize: 25,
        totalListSize: 0,
      },
      userInfo: {},
      modalTraffic: false,
      currentRow: {},
      grapCustId: "",
      weeklyChart: null,
      beforeClose: "closeGraphModal",
      searchColecDt: [],
      searchRangeDays: 31,
      searchForm : {
        custId : '',
        rackPduYn:'Y',
        firstOpnDt : [
        ],  // default placehoer 값 설정 배열
      },
    };
  },
  mounted() {
    this.getinitDate();
    this.$EventBus.$on("closeGraphModal", () => {
      this.closeGraphModal();
    });

    this.$store.dispatch("userInfoStore/getCustLoginCustInfo").then((data) => {
      this.userInfo = data;
      // this.getElectUseQntStatsListByCust(1);
      this.getUsageStatusPowerReport(1);
    });

    this.searchColecDt.push(getNow(-6));
    this.searchColecDt.push(getNow());
  },
  methods: {
    downloadExcel() {
      this.isLoadingLayer = true;
      var reqData = Object.assign(
        {
          paging: false
        },
        this.searchForm
      );

      commonExcelDownload(
        this.$BIZ_SERVICE,
        this.$API_URLS.Com.excelDownloadByService,
        "전력사용량 목록_" + getNow() + ".xlsx",
        "getUsageStatusPowerReport",
        this.tableHeader,
        reqData,
        [],
        () => {
          this.isLoadingLayer = false;
        }
      );
    },    
    getPagingUsageStatusPowerReport() {
      let curPage = this.pageInfo.curPage;

      this.getUsageStatusPowerReport(curPage);      
    },    
    initData(val){
       this.tableData = [];
       this.count = val ||this.count;
       this.pageInfo.curPage = 1;
       this.pageInfo.startIndex = 0;
       this.pageInfo.lastIndex = val;
       this.pageInfo.totalListSize = 0;

     },
    chgFirstOpnDt(val){
      let startOpDt = val[0] //개통일 시작
      let endOpDt = val[1] //개통일 끝
      this.searchForm.firstOpnDtSt = startOpDt;
      this.searchForm.firstOpnDtEt = endOpDt;
    },    
    getinitDate() {
    if(this.searchForm.firstOpnDt == null || this.searchForm.firstOpnDt.length === 0 ){
      var date = new Date();
      var day = date.getDate();
      var dateBef = new Date().setDate(day - 6);
      this.searchForm.firstOpnDt = []

      this.searchForm.firstOpnDt[1] = getDateFormatter(date, "YYYY-MM-DD");
      this.searchForm.firstOpnDt[0] = getDateFormatter(dateBef, "YYYY-MM-DD");
    }

      this.searchForm.firstOpnDt = [...this.searchForm.firstOpnDt];
      this.searchForm.firstOpnDtSt = this.searchForm.firstOpnDt[0]
      this.searchForm.firstOpnDtEt = this.searchForm.firstOpnDt[1]
    } ,   
  getUsageStatusPowerReport(curPage) {
    this.searchForm.custId = this.userInfo.custId;
        const requestData = 
          {
            curPage: curPage,
            // curPage: this.pageInfo.curPage,
            startIndex: this.pageInfo.startIndex,
            lastIndex: this.pageInfo.lastIndex,
            pageListSize: this.count,
            paging: true,
            rackPduYn : "Y",
            custId: this.searchForm.custId,
            firstOpnDtSt : this.searchForm.firstOpnDtSt,
            firstOpnDtEt : this.searchForm.firstOpnDtEt,
          }
      let reqData = Object.assign(
        {
          pageListSize : this.count,
          paging: true
        },
        this.pageInfo,
        this.searchForm
      );
      this.$BIZ_SERVICE
        .post(this.$API_URLS.Sta.getUsageStatusPowerReportByCust, requestData)
        .then((response) => {
          setTimeout(() => {
            const resData = response.data.resData;
            if (resData.list.length > 0) {
              this.tableData = resData.list;
              this.pageInfo = resData.page;
            } else {
              this.tableData = [];
              //$state.complete();
            }
          }, 500);
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          // let today = this.formatSysdate();
          this.isLoadingLayer = false;
        });
    },
    clickRow(col, row) {
      this.currentRow = row;
    },

    async openGraphModal() {
      if (Object.keys(this.currentRow).length === 0) {
        alert(this.$t("messages.msgSelectRack"));
        return;
      }

      if (this.currentRow.rackAssetNm == null) {
        alert(this.$t("messages.msgSelectRack"));
        return;
      }

      // 선택일
      // let date = this.searchColecDt[1];
      // this.modalKey = new Date(date).getTime();

      // 오늘 기준
      this.modalKey = Date.now();

      
      this.modalTitle = "전력사용량 조회";
      this.popType = "powerlist";
      this.trafficData ={ 
      count: this.currentRow.rackTotElect,
      level: "정상",
      popType: "powerlist",
      title: "전력사용량",
      unit: "kw",
      // colecDtSt: this.searchColecDt[0],
      // colecDtEt: this.searchColecDt[1],
      colecDtSt: this.searchForm.firstOpnDtSt,
      colecDtEt: this.searchForm.firstOpnDtEt,
      rackNm : this.currentRow.rackAssetNm,
      index : this.currentRow.rn,
      tableData : this.tableData
      
      }// 실제 조회 데이터로 변환 해야함.

      this.modalPower = true;

      // const cbNos = this.currentRow.ifInfos.split(",");
      // const domain = [0, 1]; // 값의 범위 (최소, 최대)
      // const legend = {};
      // for (let legendSet of cbNos) {
      //   let splitData = legendSet.split("|");
      //   legend[legendSet] = splitData[0] + "(" + splitData[1] + ")";
      // }

      // let chart2Data = [];
      // const data2 = await this.getPower7D(this.currentRow.rackNo, cbNos);
      // if (data2.length > 0) {
      //   const parseDats = parseDateRange(this.searchColecDt, this.searchRangeDays);
      //   const statDates = getDateStatisticsRange(parseDats[0], parseDats[1]);
      //   for (let date of statDates) {
      //     chart2Data.push({ colecDt: date });
      //   }

      //   var arrAvg = [];
      //   for (let cTmp of chart2Data) {
      //     for (let tmpCbNo of cbNos) {
      //       cTmp[tmpCbNo] = 0.0;
      //     }
      //   }
      //   for (let cTmp of chart2Data) {
      //     for (let tmpData of data2) {
      //       if (tmpData.colecDt == cTmp.colecDt) {
      //         let tmpKey = tmpData.ifPsmName + "|" + tmpData.ifCbNo;
      //         if (cTmp[tmpKey] == 0.0) {
      //           cTmp[tmpKey] = tmpData.avgUseQnt;
      //           arrAvg.push(tmpData.avgUseQnt);
      //         }
      //       }
      //     }
      //   }

      //   domain[1] = Math.floor(Math.max(...arrAvg)) + 1;

      //   setTimeout(() => {
      //     this.setChart2(chart2Data, legend, domain, "colecDt", cbNos);
      //   }, 300);
      //   this.modalTraffic = true;
      // } else {
      //   alert(this.$t("messages.msgNodata"));
      // }
    },
    closeGraphModal() {
      if (this.weeklyChart != null) {
        /*
        console.log(this.weeklyChart)
        

        // this.weeklyChart.destory();
        this.weeklyChart.svg.clear();
        this.weeklyChart = null;
        */
      }
    },

    setChart2(data, legend, domain, categolyName, axisNames) {
      if (this.weeklyChart == null) {
        let chart = jui.include("chart.builder");
        this.weeklyChart = chart(".graph-area-weekly", {
          padding: {
            bottom: 90
          },
          axis: [
            {
              x: {
                type: "fullblock",
                domain: categolyName,
                line: "soild",
                textRotate: -30,
                // format: function (d, cnt) { return d.substring(0,4) + '-' + d.substring(4,6) + '-' + d.substring(6,8); },
              },
              y: {
                type: "range",
                domain: domain,
                line: "solid",
                step: 5,
              },
              data: data,
            },
          ],
          brush: [
            {
              type: "line",
              axis: [0],
              target: axisNames,
              animate: true,
            },
          ],
          widget: [
            {
              type: "legend",
              filter: true,
              brush: [0],
              format: function (k) {
                return legend[k];
              },
              orient: "bottom",
            },
          ],
          style: {
            gridTickPadding: 12,
          },
        });
      } else {
        setTimeout(() => {
          this.weeklyChart.axis(0).updateGrid("y", {
            type: "range",
            domain: domain,
            line: "solid",
            step: 5,
          });
          this.weeklyChart.updateBrush(0, {
            type: "line",
            target: axisNames,
            animate: true,
          });
          this.weeklyChart.updateWidget(0, {
            type: "legend",
            format: function (k) {
              return legend[k];
            },
          });
          this.weeklyChart.axis(0).update(data);
          this.weeklyChart.render(true);
        }, 300);
      }
    },

    async getPower7D(itemId, itemId2) {
      const parseDats = parseDateRange(this.searchColecDt, this.searchRangeDays);
      if (parseDats.length == 0) {
        alert("조회 기간 최대 일은 " + this.searchRangeDays + "일 입니다.");
        return;
      }

      const { data } = await this.$BIZ_SERVICE.post(
        this.$API_URLS.Com.getPower7D,
        {
          isDefault: false,
          itemId: itemId,
          itemId2: itemId2,
          colecDtSt: parseDats[0],
          colecDtEt: parseDats[1],
        }
      );
      if (data.resData.length > 0) {
        return data.resData;
      }
      return [];
    },
    movePage(curPage) {
      this.getUsageStatusPowerReport(curPage);
      // this.getElectUseQntStatsListByCust(curPage);
    },
    getElectUseQntStatsListByCust(curPage) {
      if (this.userInfo.custId == null || this.userInfo.custId == "") {
        this.tableData = [];
        return;
      }

      const reqData = {};
      reqData.curPage = curPage;
      reqData.paging = true;
      reqData.srchCustId = this.userInfo.custId;

      const parseDats = parseDateRange(this.searchColecDt, this.searchRangeDays);
      // const parseDats = parseDateRange(this.searchColecDt, 40);
      // if (parseDats.length == 0) {
      //   alert("조회 기간 최대 일은 " + this.searchRangeDays + "일 입니다.");
      //   return;
      // }

      reqData.colecDtSt = parseDats[0];
      reqData.colecDtEt = parseDats[1];

      this.$BIZ_SERVICE
        .post(this.$API_URLS.Sta.getElectUseQntStatsListByCust, reqData)
        .then((res) => {
          let data = res.data.resData.list;
          data.forEach((tmp) => {
            tmp.contElect = 2.2;
            tmp.avgUseQnt = Math.round(tmp.avgUseQnt * 100) / 100;
            tmp.maxUseQnt = Math.round(tmp.maxUseQnt * 100) / 100;
            tmp.minUseQnt = Math.round(tmp.minUseQnt * 100) / 100;

            /*
          var arrTimeAvg = [];
          for (let i = 1; i < 24; i++) {
            arrTimeAvg.push( tmp['avg' + (i < 10 ? '0' + i : i)] == null ? 0.00 : Math.round(tmp['avg' + (i < 10 ? '0' + i : i)] * 100) / 100 );
          }
          tmp.minUseQnt = Math.min(...arrTimeAvg);
          tmp.maxUseQnt = Math.max(...arrTimeAvg);
          */
          });

          // this.tableData = data;
          // this.pageInfo = res.data.resData.page;

          // this.totalSize = this.pageInfo.totalListSize;
        })
        .catch((error) => {})
        .finally(() => {});
    },
    excelDownload() {
      if (this.tableData.length == 0) {
        alert(this.$t("messages.msgNodata"));
        return;
      }

      const reqData = {};
      reqData.srchCustId = this.userInfo.custId;
      reqData.paging = false;

      const parseDats = parseDateRange(this.searchForm.firstOpnDtSt,this.searchForm.firstOpnDtEt);
      reqData.colecDtSt = parseDats[0];
      reqData.colecDtEt = parseDats[1];

      commonExcelDownload(
        this.$BIZ_SERVICE,
        this.$API_URLS.Com.excelDownloadByService,
        "전력사용량_목록_" + getNow() + ".xlsx",
        "getUsageStatusPowerReport",
        this.tableHeader,
        reqData
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.ly-sort-his {
  //공통 / 삭제
  display: flex;
  padding: 0 0 10px 0;
  justify-content: space-between;
  align-items: center;
  .table-cell {
    &-all {
      font-size: $--font-size-base;
      line-height: 26px;
      display: inline-block;
      vertical-align: middle;
    }
    &-count {
      margin-left: 8px;
      font-weight: $--font-weight-bold;
    }
    &-notice {
      //추가
      margin-left: 32px;
      color: $--color-success;
      list-style-type: disc;
    }
  }
  .sort {
    &-count {
      display: flex;
      align-items: center;
    }
    &-select {
      display: inline-block;
      vertical-align: middle;
      color: $--color-black;
      .el-select {
        display: inline-block;
        vertical-align: middle;
        width: 80px;
        margin: 0 8px;
      }
      span {
        display: inline-block;
        vertical-align: middle;
      }
    }
  }
}
.graph {
  .graph {
    &-title {
      margin: 20px 0 0 0;
      font-size: $--font-size-medium;
      font-weight: $--font-weight-Medium;
      position: relative;
      z-index: 3;
    }
    &-area {
      height: 380px;
      margin-top: -30px;
    }
    &-list {
      width: 800px;
      height: 50px;
      margin: 0 0 20px 25px;
      ul {
        width: 33%;
        float: left;
      }
      li {
        display: list-item;
        list-style-type: disc;
        margin-top: 5px;
        b {
          color: $--color-primary;
        }
        i {
          color: $--work-flow-pend-background-color;
        }
      }
    }
  }
}
</style>
